import React, { useEffect, useState } from 'react';
import { Input, Menu, Layout, Select, Form, Typography, Row, Col, Slider, Switch } from 'antd';
import './HeaderComponent.css';
import { usePermissions } from './PermissionsProvider';
import { SandboxMessage } from './model_gen/sandbox';
import CompletionConfigComponent from './CompletionConfigComponent';

// Define an interface for the component props
interface CompletionComponentProps {
    targetMessage: SandboxMessage | null;
}

const CompletionComponent: React.FC<CompletionComponentProps> = ({ targetMessage }) => {
    const { apiKey } = usePermissions()
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        if (apiKey) {
        }
    }, [apiKey]) // Added apiKey as a dependency

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        targetMessage ? (
            <div style={{
                width: '100%', 
                height: 'auto', 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'start', 
                gap: '20px',
                boxSizing: 'border-box'
            }}>
                <CompletionConfigComponent targetMessage={targetMessage} />
            </div>
        ) : (
            <div style={{
                width: '100%', 
                height: 'calc(100% - 20px)', 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'start', 
                background: 'rgba(0,0,0,0.02)', 
                borderRadius: '10px', 
                padding: isMobile ? '20px' : '40px', 
                gap: '20px', 
                justifyContent: 'center',
                boxSizing: 'border-box'
            }}>
                <Typography style={{
                    fontSize: isMobile ? '16px' : '18px', 
                    color: 'rgba(0,0,0,0.2)', 
                    textAlign: 'center',
                    width: '100%'
                }}>
                    Select a bot message to see details
                </Typography>
            </div>
        )
    );
}

export default CompletionComponent;
